import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./styles/Thankyou.css";

export default function ThankYou() {
  const [searchParams] = useSearchParams();
  const ticketId = searchParams.get("ticketId") || "12345";
  // Parse bulk upload response if present
  let bulkResponse = null;
  try {
    const bulk = searchParams.get("bulkResponse");
    if (bulk) {
      bulkResponse = JSON.parse(decodeURIComponent(bulk));
    }
  } catch {}

  useEffect(() => {
    // Disable back navigation
    const handlePopState = () => {
      window.history.go(1);
    };
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="container">
      <div className="card">
        <div className="icon-success">✓</div>
        <h1>Thank You!</h1>
        <p>
          Your documents have been successfully submitted for TicketId{" "}
          <span className="ticket-id">#{ticketId}</span>.
        </p>
        {bulkResponse ? (
          <>
            <p>{bulkResponse.message}</p>
            <ul>
              {bulkResponse.successfulUploads &&
                bulkResponse.successfulUploads.length > 0 && (
                  <li>
                    <strong>Successful Uploads:</strong>
                    <ul className="success-list">
                      {bulkResponse.successfulUploads.map((item, idx) => (
                        <li key={idx} className="success-item">
                          <span className="file-icon">📄</span>
                          <span className="file-name">{item.name}</span>
                          <span className="file-id">(ID: {item.id})</span>
                        </li>
                      ))}
                    </ul>
                  </li>
                )}
              {bulkResponse.errors && bulkResponse.errors.length > 0 && (
                <li style={{ color: "red" }}>
                  <strong>Errors:</strong>
                  <ul>
                    {bulkResponse.errors.map((err, idx) => (
                      <li key={idx}>{err}</li>
                    ))}
                  </ul>
                </li>
              )}
            </ul>
          </>
        ) : (
          <p>Our team will review your submission and update you via email.</p>
        )}
      </div>
      <footer>
        <p>HubSpot Dispute-Document Upload Portal &copy; 2025</p>
      </footer>
    </div>
  );
}
